import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  DoughnutController,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js";

import { ReadThemeToken } from "Components";

/**
 * chart.js 3 ağaç sarsılabilir (tree-shakeable) — kullanılan denetleyici,
 * eleman ve eklentiler açıkça kaydedilmeli.
 */
ChartJS.register(
  BarController,
  LineController,
  DoughnutController,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend,
);

ChartJS.defaults.font.family = "'Source Sans Pro', sans-serif";
ChartJS.defaults.maintainAspectRatio = false;

export const CHART_FONT = "'Source Sans Pro', sans-serif";

/** Grafiklerin kullandığı tema token'larını tek seferde okur. */
export function ReadChartPalette() {
  return {
    primary: ReadThemeToken("--primary"),
    teal: ReadThemeToken("--teal"),
    amber: ReadThemeToken("--amber"),
    violet: ReadThemeToken("--violet"),
    border: ReadThemeToken("--border"),
    border2: ReadThemeToken("--border-2"),
    surface: ReadThemeToken("--surface"),
    text: ReadThemeToken("--text"),
    text2: ReadThemeToken("--text-2"),
    text3: ReadThemeToken("--text-3"),
  };
}

/** Tüm grafiklerde ortak tooltip görünümü. */
export function TooltipStyle(palette) {
  return {
    backgroundColor: palette.surface,
    borderColor: palette.border,
    borderWidth: 1,
    titleColor: palette.text,
    bodyColor: palette.text2,
    titleFont: { family: CHART_FONT, size: 12, weight: "600" },
    bodyFont: { family: CHART_FONT, size: 12 },
    padding: 10,
    displayColors: true,
  };
}

/** Eksen etiketi / kılavuz çizgisi ortak ayarları. */
export function AxisStyle(palette, { grid = true } = {}) {
  return {
    grid: {
      display: grid,
      color: palette.border,
      drawBorder: false,
      drawTicks: false,
    },
    ticks: {
      color: palette.text3,
      font: { family: CHART_FONT, size: 11, weight: "600" },
      padding: 8,
    },
  };
}

export default ChartJS;
